import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { StatsSection } from '../common/stats-section';
import { BenchmarkingExplainer } from '../../../../../../common/react/components/benchmarking';
import { KeyStatsAndPerformanceMain } from './components/KeyStatsAndPerformanceMain';
import { getTranslation } from '../../../../../../common/react/utils/translations';
import { EmptyState } from '../../../../../../common/react/components/EmptyState';
import { Loader } from '../../../../../../common/react/components/Loader';

import { useGetPlayerProfileQuery } from '../../../../store/js/modules/api/statsPro-api';

export const KeyStatsAndPerformance = ({ seasonId }) => {
    const playerId = new URLSearchParams(location.search).get('playerId');

    const [topSeasonData, setTopSeasonData] = useState(null);
    const [topCareerData, setTopCareerData] = useState(null);

    const {
        data: playerData,
        isFetching,
        isError
    } = useGetPlayerProfileQuery({ seasonId, playerId });

    useEffect(() => {
        // Fetch top season performance data
        PULSE.app.common.misApi.request({
            url: `${PULSE.app.environment.cfsApi}/statsCentre/player/best/season?playerId=${playerId}`,
            callback: (response) => setTopSeasonData(response)
        });

        // Fetch top career performance data
        PULSE.app.common.misApi.request({
            url: `${PULSE.app.environment.cfsApi}/statsCentre/player/best/career?playerId=${playerId}`,
            callback: (response) => setTopCareerData(response)
        });
    }, []);

    return (
        <StatsSection.Main>
            <StatsSection.Content>
                <StatsSection.ContentHeader>
                    <StatsSection.ContentHeaderHeading>
                        <div className="key-stats-and-performance__header-text-wrapper">
                            <strong>
                                {playerData?.seasonTotals?.matchesPlayed ?? '-'}{' '}
                                {getTranslation('label.stats.matches')}
                            </strong>{' '}
                            {getTranslation('label.stats.thisSeason')}
                        </div>
                        <span className="key-stats-and-performance__header-text-divider"></span>
                        <div className="key-stats-and-performance__header-text-wrapper">
                            <strong>
                                {playerData?.careerTotals?.matchesPlayed ?? '-'}{' '}
                                {getTranslation('label.stats.matches')}
                            </strong>{' '}
                            {getTranslation('label.stats.inCareer')}
                        </div>
                    </StatsSection.ContentHeaderHeading>
                    <StatsSection.ContentHeaderOptions>
                        <BenchmarkingExplainer />
                    </StatsSection.ContentHeaderOptions>
                </StatsSection.ContentHeader>
                <StatsSection.ContentBody>
                    {isFetching || isError ? (
                        <div className="key-stats-and-performance__loader">
                            <Loader />
                        </div>
                    ) : (
                        <>
                            {playerData.seasonAverages &&
                            playerData.careerAverages ? (
                                <KeyStatsAndPerformanceMain
                                    playerData={playerData}
                                    topSeasonData={topSeasonData}
                                    topCareerData={topCareerData}
                                />
                            ) : (
                                <div className="key-stats-and-performance__empty-state">
                                    <EmptyState />
                                </div>
                            )}
                        </>
                    )}
                </StatsSection.ContentBody>
            </StatsSection.Content>
        </StatsSection.Main>
    );
};

KeyStatsAndPerformance.propTypes = {
    seasonId: PropTypes.string.isRequired
};
